import { render, staticRenderFns } from "./UnitsGroupContainer.vue?vue&type=template&id=43038c76&scoped=true"
import script from "./UnitsGroupContainer.vue?vue&type=script&lang=js"
export * from "./UnitsGroupContainer.vue?vue&type=script&lang=js"
import style0 from "./UnitsGroupContainer.vue?vue&type=style&index=0&id=43038c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43038c76",
  null
  
)

export default component.exports